export default __webpack_public_path__ + "static/media/mobile-image-hero-2.51db290a.jpg";